import React, { Component } from "react";

import {
  StyleSheet,
  TouchableOpacity,
  Content,
  View,
  Icon,
  ListView,
  Modal,
  Navigator,
  RefreshControl,
  Text
} from "react-1app";
import { Model } from "../infra";
import * as actions from "../redux/actions.js";

import Menu from "./Menu.js";
import Criarlogin from "./Criarlogin.js";
import VerSenha from "./VerSenha.js";

export default class Gerenciador extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    Navigator.cloneState(this);
  }

  componentDidMount() {
    this.unsubscribe = this.props.screenProps.store.subscribe(() => {
      this.setState(this.props.screenProps.store.getState());
    });
    this.queryUser_local();
  }

  componentWillUnmount() {
    if (this.unsubscribe) this.unsubscribe();
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps != this.props) {
      this.queryUser_local();

      //this.onUpdate(nextProps,nextState)
    }
    return true;
  }
  openModalAdajuda11() {
    this.props.screenProps.navigator.openModal({
      component: Criarlogin,
      props: {
        activity: this,
        oldState: this.state
      }
    });
  }

  queryUser_local() {
    actions.usuariosBuscaTodos(ret => {
      this.setState({
        list: ret,
        listUser_local: ret,
        loadUser_local: false
      });
    });
  }

  render() {
    return (
      <Content style={styles.content}>
        <Menu
          style={styles.fragment}
          screenProps={this.props.screenProps}
          navigation={this.props.navigation}
          activity={this}
          oldState={this.state}
        />
        <View style={styles.view}>
          <View style={styles.view1}>
            <Icon
              style={styles.icon11}
              fromFontFamily={"Material Icons"}
              name={"keyboard_arrow_right"}
            />
            <Text style={styles.text4} text={"Gerenciador de Usuários"} />
          </View>
          <ListView
            style={styles.user_local}
            refreshControl={
              <RefreshControl
                refreshing={this.state.loadUser_local}
                onRefresh={() => {
                  this.setState({ loadUser_local: true });
                  this.queryUser_local();
                }}
              />
            }
            dataSource={this.state.listUser_local}
            renderHeader={() => {
              return (
                <Head
                  navigation={this.state.navigation}
                  screenProps={this.props.screenProps}
                  activity={this}
                  oldState={this.state}
                />
              );
            }}
            renderRow={(rowData, sectionID, rowID) => {
              return (
                <Cell
                  usuario={rowData}
                  screenProps={this.props.screenProps}
                  oldState={this.state}
                  activity={this}
                  navigation={this.state.navigation}
                  rowID={rowID}
                  sectionID={sectionID}
                />
              );
            }}
            colorSeparator={"rgba(227,227,227,1)"}
            ref={v => (this.user_local = v)}
            ref={v => (this.user_local = v)}
          />
        </View>
      </Content>
    );
  }
}

class Head extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    Navigator.cloneState(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps != this.props) Navigator.updateState(nextProps, nextState);
    if (nextProps != this.props) {
      //this.onUpdate(nextProps,nextState)
    }
    return true;
  }

  componentDidMount() {}

  componentWillUnmount() {}

  render() {
    return (
      <View style={styles.head}>
        <View style={styles.view11}>
          <Text style={styles.label} text={"USUÁRIO"} />
        </View>
        <View style={styles.view2}>
          <Text style={styles.label1} text={"LOGIN"} />
        </View>
        <View style={styles.view3}>
          <Text style={styles.label2} text={"SENHA"} />
        </View>
      </View>
    );
  }
}
class Cell extends Component {
  constructor(props) {
    super(props);
    this.state = { usuario: new Model("usuario") };
    Navigator.cloneState(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps != this.props) Navigator.updateState(nextProps, nextState);
    if (nextProps != this.props) {
      //this.onUpdate(nextProps,nextState)
    }
    return true;
  }

  componentDidMount() {}

  componentWillUnmount() {}

  openModalEditar() {
    this.props.screenProps.navigator.openModal({
      component: Criarlogin,
      props: {
        activity: this,
        oldState: this.state
      }
    });
  }

  openModalVersenha() {
    this.props.screenProps.navigator.openModal({
      component: VerSenha,
      props: {
        activity: this.props.activity,
        oldState: this.state,
        senhaantiga: this.state.usuario.senha,
        usuario: this.state.usuario
      }
    });
  }

  render() {
    return (
      <TouchableOpacity style={styles.cell}>
        <View style={styles.view5}>
          <Text style={styles.nome} text={this.state.usuario.nome} />
        </View>
        <View style={styles.view8}>
          <Text style={styles.email} text={this.state.usuario.login} />
        </View>
        <View style={styles.view12}>
          <TouchableOpacity
            style={styles.versenha}
            onPress={() => {
              this.openModalVersenha();
            }}
          >
            <Text style={styles.label6} text={"Editar Senha"} />
          </TouchableOpacity>
        </View>
      </TouchableOpacity>
    );
  }
}

var styles = StyleSheet.create({
  content: {
    backgroundColor: "rgba(255,255,255,1)",
    alignSelf: "stretch",
    flex: 1,
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "row"
  },
  fragment: {
    alignSelf: "stretch"
  },
  view: {
    alignSelf: "stretch",
    flex: 1,
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexDirection: "column"
  },
  view1: {
    alignSelf: "stretch",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-start",
    flexWrap: "nowrap",
    padding: 10,
    backgroundColor: "rgba(238,238,238,1)"
  },
  icon11: {
    color: "rgba(181,181,181,1)",
    fontSize: 25
  },
  text4: {
    textAlign: "left",
    color: "rgba(0,0,0,1)",
    alignSelf: "auto",
    fontWeight: "normal",
    flex: 1,
    fontSize: 14
  },
  user_local: {
    alignSelf: "stretch",
    flex: 1,
    paddingTop: 20
  },
  head: {
    alignSelf: "stretch",
    padding: 10,
    flexDirection: "row",
    alignItems: "flex-start",
    justifyContent: "space-between",
    flexWrap: "nowrap"
  },
  view11: {
    alignSelf: "stretch",
    flex: 1,
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    flexWrap: "nowrap",
    borderStyle: "solid",
    borderColor: "rgba(150,150,145,1)",
    borderTopWidth: 0,
    borderLeftWidth: 0,
    borderBottomWidth: 2,
    borderRightWidth: 1
  },
  label: {
    textAlign: "left",
    flexWrap: "wrap",
    color: "rgba(0,0,0,1)",
    alignSelf: "stretch",
    fontSize: 14,
    marginLeft: 10,
    fontWeight: "normal"
  },
  view2: {
    alignSelf: "stretch",
    flex: 1,
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    flexWrap: "nowrap",
    borderStyle: "solid",
    borderColor: "rgba(150,150,145,1)",
    borderTopWidth: 0,
    borderLeftWidth: 0,
    borderBottomWidth: 2,
    borderRightWidth: 1
  },
  label1: {
    textAlign: "left",
    flexWrap: "wrap",
    color: "rgba(0,0,0,1)",
    alignSelf: "stretch",
    fontSize: 14,
    marginLeft: 10
  },
  view3: {
    alignSelf: "stretch",
    flex: 1,
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    flexWrap: "nowrap",
    borderStyle: "solid",
    borderColor: "rgba(150,150,145,1)",
    borderTopWidth: 0,
    borderLeftWidth: 0,
    borderBottomWidth: 2,
    borderRightWidth: 1
  },
  label2: {
    textAlign: "left",
    flexWrap: "wrap",
    color: "rgba(0,0,0,1)",
    alignSelf: "stretch",
    fontSize: 14,
    marginLeft: 10
  },
  cell: {
    flexDirection: "row",
    alignSelf: "stretch",
    flex: 1,
    padding: 10,
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flexWrap: "nowrap"
  },
  view5: {
    alignSelf: "stretch",
    flex: 1,
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    flexWrap: "nowrap"
  },
  nome: {
    textAlign: "left",
    flexWrap: "wrap",
    color: "rgba(0,0,0,1)",
    alignSelf: "stretch",
    fontSize: 14,
    marginLeft: 10,
    fontWeight: "normal"
  },
  view8: {
    alignSelf: "stretch",
    flex: 1,
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    flexWrap: "nowrap"
  },
  email: {
    textAlign: "left",
    flexWrap: "wrap",
    color: "rgba(0,0,0,1)",
    alignSelf: "stretch",
    fontSize: 14,
    marginLeft: 10,
    fontWeight: "normal"
  },
  view12: {
    alignSelf: "stretch",
    flex: 1,
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
    flexWrap: "nowrap"
  },
  versenha: {
    alignSelf: "auto",
    justifyContent: "flex-end",
    alignItems: "flex-end",
    flexDirection: "column",
    flexWrap: "nowrap",
    borderStyle: "solid",
    borderTopWidth: 0,
    borderLeftWidth: 0,
    borderRightWidth: 0,
    borderBottomWidth: 1,
    marginLeft: 10,
    padding: 10
  },
  label6: {
    textAlign: "left",
    flexWrap: "wrap",
    color: "rgba(0,0,0,1)",
    alignSelf: "stretch",
    fontSize: 14,
    fontWeight: "normal"
  }
});



// WEBPACK FOOTER //
// ./src/views/Gerenciador.js